import { useState, useLayoutEffect } from 'react'

export function LogoutModal() {
    const [logoutModalIsOpen, setlogoutModalIsOpen] = useState(false)
    useLayoutEffect(() => {
        const elements = document.getElementsByClassName('logout-menu')
        for (const el of elements) {
            el.style.marginTop = window.innerWidth <= 1024 ? `-${el.clientHeight}px` : ''
        }
    }, [logoutModalIsOpen])

    return (
        <>
            <button
                className="hidden lg:flex leftHead message font-bold px-2 py-2 rounded outline-none focus:outline-none mr-2 mb-1"
                type="button"
                style={{ transition: 'all .15s ease' }}
                onClick={() => setlogoutModalIsOpen(true)}>
                <span className="ico flaticon-137-log-out flex align-center justify-center"></span>
                <span className="mr-2">خروج</span>
            </button>
            <a className="flex flex-col h-20 text-center  p-2 lg:hidden" onClick={() => setlogoutModalIsOpen(true)}>
                <svg
                    className="w-8  mb-1 mx-auto text-purple-300"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                </svg>
                <span className="text-gray-400 text-xs">خروج</span>
            </a>
            {logoutModalIsOpen == true && (
                <div
                    className="logout-menu z-50 fixed inset-x-0 top-0 align-bottom bg-white rounded-lg mx-auto overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                    role="dialog">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6   sm:pb-4">
                        <div className="sm:flex sm:items-start">
                            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-right">
                                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                                    خروج از حساب
                                </h3>
                                <div className="mt-2">
                                    <p className="text-sm text-gray-500">آیا میخواهید از حساب خود خارج شوید ؟</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex ">
                        <button
                            type="button"
                            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={async () => {
                                const response = await fetch('/api/auth/signout', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' }
                                })
                                if (response.status === 200) {
                                    window.localStorage.removeItem('auth')
                                    setlogoutModalIsOpen(false)
                                    window.location.reload()
                                }
                            }}>
                            خروج
                        </button>
                        <button
                            type="button"
                            className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                            onClick={() => {
                                setlogoutModalIsOpen(false)
                            }}>
                            بازگشت
                        </button>
                    </div>
                </div>
            )}
        </>
    )
}
